import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import grey from '@material-ui/core/colors/grey'
import React, { Fragment } from 'react'

import { FormHelperText } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

const styles = theme => ({
  center: {
    justifyContent: 'center'
  },
  checkboxBordered: {
    border: `solid 1px ${grey['400']}`,
    borderRadius: 28
  },
  checkboxSelected: {
    borderColor: theme.palette.primary.main
  },
  checkboxDisabled: {
    borderColor: grey['400']
  }
})

const CheckboxInput = ({
  disabled,
  simple,
  center,
  classes,
  input: { checked, onChange, ...input },
  label,
  meta
}) => {
  return (
    <Fragment>
      <FormGroup
        style={{ width: '100%' }}
        className={classNames(
          !simple && classes.checkboxBordered,
          checked && classes.checkboxSelected,
          disabled && classes.checkboxDisabled
        )}
      >
        <FormControlLabel
          classes={center && { root: classes.center }}
          control={
            <Checkbox
              {...input}
              color="primary"
              onChange={value => onChange(value)}
              checked={checked}
              disabled={disabled}
            />
          }
          label={label}
          style={{ margin: '0px' }}
        ></FormControlLabel>
      </FormGroup>

      <FormHelperText error>{meta.touched && meta.error}</FormHelperText>
    </Fragment>
  )
}

export default withStyles(styles)(CheckboxInput)
